import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr';

export const signalr = (): HubConnection => {
  const hub = new HubConnectionBuilder()
    .withUrl('https://api.reeqzan.com/reeqzan')
    .build();

  hub.start();
  return hub;
}